









































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { getFirst } from "@root/lib/addRoutes.ts";

import { API_URL } from "@root/lib/axios/ygjAxios";
const login = namespace("login");
const rootVuex = namespace("root");
@Component({})
export default class Header extends Vue {
  @login.Action loginB2BSSO;
  @login.Action loginZSTSSO;
  @rootVuex.Action getCartCount;
  @rootVuex.State headerCartNum;
  @rootVuex.Action queryMemberMessageList;
  @rootVuex.Action saveMessageLog;
  @rootVuex.State ddCodes;
  @rootVuex.State memberMessageList;
  @rootVuex.State activeRoute;
  @rootVuex.State menuList;
  @rootVuex.Action getMemberMessageCount;
  @rootVuex.Action subtractMemberMessageCount;
  @rootVuex.Action refreshMemberMessageCount;
  @rootVuex.State msgCount;
  @rootVuex.Action getSystemValue;
  @rootVuex.Action menuListByRole2;
  @rootVuex.Action refreshAccount;

  // cartNum: any = 0;
  memberName: any = "";
  marketType: any = "";
  marketList: any = [];
  hasMarketDropdown: any = false;

  channel: string = "";
  userInfo: any = {};
  tenant: any = {};
  isInit: any = false;
  breadcrumbList: any = [];
  menuListMap: any = {};
  isDev: any = false;
  dataList: any = [];
  titleMap: any = {};
  private intervalId: any = null;
  childProgramPrev: any = "";
  childPreMap: any = {
    ygj: "/app/k-one-frontend",
    tbr: "/app/k-one-tbr"
  };
  visibleFirstLogin: any = false;
  menuListResource: any = [];
  @Watch("$route", { immediate: true })
  onRouteChange(to, from: any = {}) {
    let hasOa: any = localStorage.getItem("oaStatus");
    if (!hasOa) {
      localStorage.setItem("isOaCooperation", "11");
    }
    let { path } = to;
    let { ygj, tbr } = this.childPreMap;

    this.childProgramPrev = "";
    // console.log(to, 99, path, path.indexOf("/app/k-one-frontend/"));
    let isYgj: any = path.indexOf(ygj) > -1;
    let isTbr: any = path.indexOf(tbr) > -1;
    if (!isYgj && !isTbr) {
      this.getBreadcrumb(to);
    } else {
      if (isYgj) {
        this.childProgramPrev = ygj;
      }
      if (isTbr) {
        this.childProgramPrev = tbr;
      }
    }
  }
  @Watch("activeRoute", { immediate: true })
  onActiveRouteChange(to, from: any = {}) {
    // console.log(to, 666);
    if (to.path) {
      this.getBreadcrumb(to);
    }
  }
  @Watch("channel")
  onChannelChange() {
    this.init();
  }
  @Watch("menuList", { immediate: true })
  onMenuListChange(menuList) {
    if (menuList && menuList.length > 0) {
      // 只在切换 市场类型 刷新页面时才执行
      if (localStorage.getItem("isChangeMarketType") === "1") {
        localStorage.removeItem("isChangeMarketType");
        this.setMenuLocalData(menuList);
      }
    }
    let menuListMap: any = JSON.parse(
      localStorage.getItem("menuListMap") || "{}"
    );
    if (!!menuListMap["/app/k-one-frontend/cart"]) {
      this.hasCart = true;
    } else {
      this.hasCart = false;
    }
  }
  @login.Action logout;
  isOaCooperation: any = "";
  hasCart: any = false;
  async mounted() {
    this.isOaCooperation = localStorage.getItem("isOaCooperation");
    this.isDev = (window as any).__GTECH_VARIABLES_ENV__ === "dev";
    this.judgeShowFirstLogin();
    this.init();
    setTimeout(() => {
      this.isInit = true;
    }, 5);
    await this.getMsgCountSwitch();
    this.dataRefreh();
    this.getMessageCount();
    this.initWebSokect();
    this.refreshAccountStartFn();
  }
  utterance: any = null;
  ws: any = null;
  initWebSokect() {
    console.log("---initWebSokect");
    const AuthToken = localStorage.getItem("AUTH-TOKEN-K-ONE-FRONTEND");
    let url: any = API_URL.replace("https", "wss");
    this.ws = new WebSocket(url + "/ws/e-order", [AuthToken]);
    this.ws.onopen = () => {
      console.log(
        "WebSocket已打开",
        "ws://k-one-api-dev.gtech.asia/ws/e-order"
      );
    };
    this.ws.onmessage = message => {
      const data = JSON.parse(message.data);
      const orderSource = data.orderSource;
      const msg =
        orderSource === 2
          ? "您有一笔电商快配订单，请尽快发货"
          : "您有一笔电商订单，请接单";
      const utterance = new SpeechSynthesisUtterance(msg);
      // 设置语音（只在第一次取 voices 时可能为空，要考虑异步加载）
      let voices = window.speechSynthesis.getVoices();
      if (!voices.length) {
        window.speechSynthesis.onvoiceschanged = () => {
          voices = window.speechSynthesis.getVoices();
          utterance.voice =
            voices.find(v => v.localService === true && v.lang === "zh-CN") ||
            null;
          window.speechSynthesis.speak(utterance);
        };
      } else {
        utterance.voice =
          voices.find(v => v.localService === true && v.lang === "zh-CN") ||
          null;
        window.speechSynthesis.speak(utterance);
      }
      if (window.speechSynthesis.paused) {
        window.speechSynthesis.resume();
      }
      this.getMessageCount();
    };
    this.ws.onerror = a => {
      console.log(a, "--onerror");
    };
    this.ws.onclose = a => {
      console.log(a, "--onclose");
    };
  }
  destroyed() {
    this.clear();
    this.ws.close();
  }
  msgCountSwitch: any = false;
  async getMsgCountSwitch() {
    const { valueValue } = await this.getSystemValue({
      valueCode: "ENABLE_MESSAGE_COUNT"
    });
    this.msgCountSwitch = valueValue === "1";
    // 只有返回值为 1 的时候才轮训查询count接口
  }
  async init() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.tenant = JSON.parse(localStorage.getItem("tenant"));
    this.memberName = localStorage.getItem("memberName");
    this.marketType = localStorage.getItem("marketType");
    if (this.marketType) {
      let list = JSON.parse(localStorage.getItem("loginTypeList") || "[]");
      this.marketList = list;
      this.hasMarketDropdown = list.length > 1;
    }
    let menuList = JSON.parse(localStorage.getItem("menuList"));
    if (menuList && menuList.length > 0) {
      this.setMenuLocalData(menuList);
      console.log(this.menuListMap, "this.menuListMap");
      this.getBreadcrumb(this.$route);
    }

    this.getCartCount({
      request: {
        marketType: this.marketType,
        memberType: localStorage.getItem("memberType")
      }
    });

    // this.getMessageList();
    await this.$dd.register(["K_ONE_B2B_MESSAGE_SUB_TYPE"]).query();
    this.titleMap = this.ddCodes.K_ONE_B2B_MESSAGE_SUB_TYPE_MAP || {};
    console.log(this.titleMap, 99);
  }
  setMenuLocalData(menuList) {
    this.menuListMap = {};
    this.menuListResource = [];
    this.getMenuItemMap(menuList);
    localStorage.setItem("menuListMap", JSON.stringify(this.menuListMap));
    localStorage.setItem(
      "menuListResource",
      JSON.stringify(this.menuListResource)
    );
  }
  async handleCommand(command, a) {
    console.log(command, a);
  }
  async handleLogOut() {
    try {
      await this.logout();
      window.location.reload();
    } catch (error) {
      console.log(error);
    }
  }

  // q切换市场类型
  async changeMarketType(row) {
    let { marketType, memberType, memberName, roleCode } = row;
    if (marketType === localStorage.getItem("marketType")) {
      return;
    }
    const menuList = await this.menuListByRole2({
      roleCode
    });
    console.log("---menuListByRole2");
    let data = getFirst(menuList, "children");
    console.log(data, "--getFirst");
    if (!data || !data.pageUrl) {
      localStorage.removeItem("isChangeMarketType");
      this.$message.error(`${marketType}市场类型无权限。`);
      return;
    }
    localStorage.setItem("marketType", marketType);
    localStorage.setItem("memberType", memberType);
    localStorage.setItem("memberName", memberName);
    localStorage.setItem("menuRoleCode", roleCode || "");
    localStorage.setItem("isChangeMarketType", "1");
    // if (localStorage.getItem("isChangeMarketType") === "1") {

    // localStorage.removeItem("isChangeMarketType");
    console.log(data.pageUrl, "--data.pageUrl");
    this.$router.push(data.pageUrl);
    // }
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  }
  goCart() {
    this.customerRouter("/cart");
    // this.$router.push({ name: "cart" });
  }
  getMenuItemMap(list) {
    let result: any = {};
    if (list && list.length > 0) {
      list.forEach(_ => {
        if (_.pageUrl) {
          this.menuListMap[_.pageUrl] = _.menuName;
          if (!_.children || _.children.length === 0) {
            this.menuListResource.push(_.resourceCode);
          }
        }
        let { children } = _;
        this.getMenuItemMap(children);
      });
    }
  }
  getBreadcrumb(to) {
    this.breadcrumbList = [];
    let {
      meta: { activeMenuIndex, breadcrumbs = [] },
      path
    } = to;
    if (activeMenuIndex) {
      let realActiveMenuIndex: any = this.childProgramPrev + activeMenuIndex;
      this.breadcrumbList.push({
        title: this.menuListMap[realActiveMenuIndex],
        path: activeMenuIndex
      });
      if (breadcrumbs && breadcrumbs.length > 0) {
        this.breadcrumbList = [...this.breadcrumbList, ...breadcrumbs];
      }
    } else {
      let realActiveMenuIndex: any = this.childProgramPrev + path;
      if (this.menuListMap[realActiveMenuIndex]) {
        this.breadcrumbList.push({
          title: this.menuListMap[realActiveMenuIndex]
        });
      } else {
        if (breadcrumbs && breadcrumbs.length > 0) {
          this.breadcrumbList = [...this.breadcrumbList, ...breadcrumbs];
        }
      }
    }
  }
  pageNum: any = 1;
  pageSize: any = 50;
  msgLoading: any = false;
  msgTotal: any = 0;
  async getMessageCount() {
    if (!this.msgCountSwitch) {
      return;
    }
    let memberCode = localStorage.getItem("memberCode");
    let { code } = await this.getMemberMessageCount({
      input: {
        messageType: "21",
        memberCode,
        isRead: 1,
        marketType: this.marketType
      }
    });
  }
  async getMessageList() {
    let memberCode = localStorage.getItem("memberCode");
    let size: any = this.pageNum * this.pageSize;
    let { list, total } = await this.queryMemberMessageList({
      input: {
        messageType: "21",
        memberCode,
        pageSize: size,
        pageNum: 1,
        isRead: 1,
        marketType: this.marketType
      }
    });
    this.msgTotal = total;
    if (this.msgCount !== this.msgTotal) {
      await this.refreshMemberMessageCount({
        input: {
          memberCode,
          messageType: "21",
          marketType: this.marketType
        },
        count: this.msgTotal
      });
      this.getMessageCount();
    }
    // this.dataList = res.filter(item => Number(item.isRead) === 0);
  }
  // 顶部消息弹出层滚动翻页，情况特殊直接定死请求第一页数据，更改pageSize(防止当下有新消息进入)
  async loadMore() {
    // 如果正在加载中，退出
    if (this.msgLoading) return;
    // 如果当前显示消息条数已经达到返回的总数，退出
    if (this.msgTotal <= this.memberMessageList.length) return;
    this.msgLoading = true;
    this.pageNum++;
    console.log("---enter load more--- pageNum:", this.pageNum);
    try {
      await this.getMessageList();
    } finally {
      this.msgLoading = false;
    }
  }
  // 打开消息弹出是清楚定时器
  async msgShowFn() {
    clearInterval(this.intervalId);
    this.intervalId = null;
    // if (!this.msgCount) return;
    try {
      this.pageNum = 1;
      this.msgLoading = true;
      await this.getMessageList();
    } finally {
      this.msgLoading = false;
    }
  }
  // 关闭消息弹层时，打开定时器，并且重置页面为1
  msgHideFn() {
    this.pageNum = 1;
    this.dataRefreh();
  }

  async messageDialogChange(item) {
    let memberCode = localStorage.getItem("memberCode");
    await this.saveMessageLog({
      input: [
        {
          messageCode: item.messageCode,
          memberCode
        }
      ]
    });

    await this.subtractMemberMessageCount({
      input: {
        memberCode,
        messageType: "21",
        marketType: this.marketType
      },
      count: 1
    });
    await this.getMessageCount();
    this.getMessageList();
    if (item.messageSubType === "216111") {
      // this.$router.push("/eInvoice");
      this.customerRouter("/eInvoice");
    } else if (item.messageSubType === "215111") {
      this.customerRouter("/cart");
    } else if (["217111", "217112"].includes(item.messageSubType)) {
      // 跳转到 电商发货页面
      this.customerRouter("/ecommerce/shippingOrder");
    } else if (["217113", "217114"].includes(item.messageSubType)) {
      // 跳转到 电商退货页面
      this.customerRouter("/ecommerce/returnOrder");
    } else {
      try {
        let desc = JSON.parse(item.des);
        if (desc && desc.orderPurchaseCode) {
          this.customerRouter("/order/detail/" + desc.orderPurchaseCode);
          // this.$router.push("/order/detail/" + desc.orderPurchaseCode);
        }
      } catch (e) {
        //
      }
    }
  }

  async isReadSave() {
    let memberCode = localStorage.getItem("memberCode");
    let list = this.memberMessageList.map(val => {
      return {
        messageCode: val.messageCode,
        memberCode
      };
    });
    await this.saveMessageLog({
      input: list
    });
    await this.subtractMemberMessageCount({
      input: {
        memberCode,
        messageType: "21",
        marketType: this.marketType
      },
      count: list.length
    });
    await this.getMessageCount();
    this.getMessageList();
  }
  goAccount() {
    this.customerRouter("/account");
    // let appCode = window.__GTECH_VARIABLES_APP_CODE__;
    // let path: any = "";
    // if (appCode === "K-ONE") {
    //   path = "/account";
    // } else {
    //   path = "/app/k-one-frontend/account";
    // }
    // this.$router.push({
    //   path
    // });
  }

  // 定时刷新数据函数
  dataRefreh() {
    if (!this.msgCountSwitch) {
      return;
    }
    // 计时器正在进行中，退出函数
    if (this.intervalId != null) {
      return;
    }
    // 计时器为空，操作
    this.intervalId = setInterval(() => {
      this.getMessageCount(); //加载数据函数
    }, 300000);
    // 接口请求频繁，临时改成5分钟（5*60*1000） 300000
  }

  // 停止定时器
  clear() {
    clearInterval(this.intervalId); //清除计时器
    this.intervalId = null; //设置为null
    clearInterval(this.interRefreshAccount); //清除计时器
    this.interRefreshAccount = null; //设置为null
  }
  customerRouter(path) {
    let appCode = window.__GTECH_VARIABLES_APP_CODE__;
    if (appCode !== "K-ONE") {
      path = "/app/k-one-frontend" + path;
    }
    this.$router.push({
      path
    });
  }
  judgeShowFirstLogin() {
    let val: any = localStorage.getItem("firstLogin");
    if (val === "1") {
      this.visibleFirstLogin = true;
    } else {
      this.visibleFirstLogin = false;
    }
  }
  closedFirstLoginDialogFn() {
    localStorage.setItem("firstLogin", "0");
  }
  cancelFirstLoginFn() {
    localStorage.setItem("firstLogin", "0");
    this.visibleFirstLogin = false;
  }
  goUpdatePswFn() {
    localStorage.setItem("firstLogin", "0");
    this.visibleFirstLogin = false;
    this.customerRouter("/account");
  }
  interRefreshAccount: any = null;
  // 30秒轮询一次账号是否需要踢出
  refreshAccountStartFn() {
    clearInterval(this.interRefreshAccount);
    this.interRefreshAccount = setInterval(() => {
      this.refreshAccount();
    }, 30000);
  }
}
